import { useTranslation } from 'react-i18next';

export default function TeachingCard({ item, onOpen }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={() => onOpen(item)}
      className="card flex w-full flex-col items-start gap-2 text-left"
    >
      <div className="flex w-full flex-wrap items-baseline gap-x-3 gap-y-1">
        <span className="text-[0.7rem] font-semibold uppercase tracking-[0.15em] text-gold">
          {t(`teaching.types.${item.type}`)}
        </span>
        {item.level && (
          <span className="text-[0.7rem] uppercase tracking-[0.12em] text-ink-muted">
            {t(`teaching.levels.${item.level}`)}
          </span>
        )}
      </div>
      <h3 className="font-serif text-lg font-semibold text-cream">{item.title}</h3>
      {item.author && <p className="text-sm text-ink-secondary">{item.author}</p>}
      {item.institution && (
        <p className="text-sm text-ink-secondary">{item.institution}</p>
      )}
      {item.description && (
        <p className="line-clamp-3 text-sm text-ink-secondary">{item.description}</p>
      )}
    </button>
  );
}
